import {Injectable} from '@angular/core';

@Injectable()
export class AnalyticService {

  trackSignup() {
    const dataLayer = window['dataLayer'] = window['dataLayer'] || [];
    dataLayer.push({
      'event': 'trackGoal',
      'goalName': 'Account Signup'
    });
  }

  termsAndConditionsPageView() {
    const dataLayer = window['dataLayer'] = window['dataLayer'] || [];
    dataLayer.push({
      'event': 'trackPV',
      'vPage': '/terms-and-conditions',
      'vPageTitle': 'User Registration'
    });
  }

  signUpPageView() {
    const dataLayer = window['dataLayer'] = window['dataLayer'] || [];
    dataLayer.push({
      'event': 'trackPV',
      'vPage': '/accounts',
      'vPageTitle': 'User Registration'
    });
  }
}
